import { categoryUrl } from '../../utils/slug';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import API from '../../utils/api';
import { useAuth } from '../../context/AuthContext';
import { useFailedImages } from '../../hooks/useFailedImages';
import { getCategoryIcon } from '../../utils/categoryIcons';
import ServiceCardGrid from '../Showcase/ServiceCardGrid';
import './ServicesSection.css';
import './WeddingServices.css';

const SERVER_URL = (API.defaults?.baseURL || 'http://localhost:5000/api').replace(/\/api\/?$/, '');
const imgUrl = path => (path && path.startsWith('/') ? `${SERVER_URL}${path}` : path);

const ServicesSection = ({ onLoginClick }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { user } = useAuth();
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAll, setShowAll] = useState(false);
    const [failedImages, markImageFailed] = useFailedImages();

    useEffect(() => {
        let cancelled = false;

        const loadAutoGenerated = async () => {
            try {
                const response = await API.get('/services/categories');
                if (cancelled) return;
                setServices((response.data.categories || []).map(category => ({
                    title: category.name,
                    desc: category.listingCount > 0
                        ? `${category.listingCount} active ${category.listingCount === 1 ? 'listing' : 'listings'} from ${category.providerCount || 1} ${category.providerCount === 1 ? 'provider' : 'providers'}`
                        : `${category.providerCount} registered ${category.providerCount === 1 ? 'provider' : 'providers'} — listings coming soon`,
                    image: category.image ? imgUrl(category.image) : '',
                    category: category.name,
                })));
            } catch (error) {
                if (!cancelled) setServices([]);
            }
        };

        const load = async () => {
            try {
                const response = await API.get('/service-cards');
                const cards = response.data.cards || [];
                if (cards.length > 0) {
                    if (!cancelled) {
                        setServices(cards.map(card => ({
                            title: card.name,
                            desc: card.description || '',
                            image: card.image ? imgUrl(card.image) : '',
                            category: card.category || '',
                            glow: card.glow || '',
                        })));
                    }
                    return;
                }
            } catch (error) {
                // A fresh installation may not have curated cards yet.
            }
            await loadAutoGenerated();
        };

        load().finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, []);

    const goToCategory = category => {
        if (!user) {
            onLoginClick?.();
            return;
        }
        navigate(categoryUrl(category));
    };

    const tiles = services.slice(0, 6);

    return (
        <section className="ws-section" aria-labelledby="home-services-title">
            <div className="ws-inner">
                <div className="ws-copy">
                    <p className="ws-eyebrow">Beyond Matrimony</p>
                    <h2 id="home-services-title">Complete Wedding Services in One Place</h2>
                    <p>From photography to catering, we connect you with trusted wedding service providers to make your big day special.</p>
                </div>

                <div className="ws-tiles">
                    {/* hexagon cards from the admin Service cards (all active cards); falls back to a short message when there are none */}
                    <ServiceCardGrid
                        className="svc-grid--section"
                        limit={8}
                        cols={4}
                        onSelect={goToCategory}
                        fallback={<div className="ws-empty">Verified wedding professionals are joining every day. Service listings are coming soon.</div>}
                    />
                </div>

                <div className="ws-more"><button type="button" className="ws-cta" onClick={() => navigate('/all-services')}> Explore Wedding Services <ArrowRight size={16} /> </button></div>
            </div>
        </section>
    );
};

export default ServicesSection;
